/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

// Statiegeld-lines worden verborgen voor de klant — ze tellen ook niet mee in
// het zichtbare item-totaal in de header / drawer / mini-cart.
function getVisibleItemCount(cart) {
    if (!cart) return 0;
    const items = cart.items || [];
    const depositQty = items.reduce(((sum, item) => item?.properties?._deposit_role === "deposit" ? sum + Number(item.quantity || 0) : sum), 0);
    return Math.max(0, Number(cart.item_count || 0) - depositQty);
}

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            this.itemsCount.innerHTML = getVisibleItemCount(state.cart).toString();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
